import type { Application, Route } from '../types';
import { applicationRouteDirectionLabel } from './addressUtils';

export type ApplicationLinkedRouteRow = {
  linkId: number;
  routeId: number;
  label: string;
  carrierName: string | null;
  status: string;
  rateAmount: number | null;
  direction: string;
  plannedLoadingDate: string | null;
  plannedUnloadingDate: string | null;
  actualLoadingDate: string | null;
  actualUnloadingDate: string | null;
};

function formatRouteDate(value: string | null | undefined): string | null {
  if (!value || !String(value).trim()) return null;
  const d = new Date(String(value));
  if (Number.isNaN(d.getTime())) return null;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
}

function projectRouteRow(link: { id: number; routeId: number; route?: Route | null }): ApplicationLinkedRouteRow {
  const route = link.route;
  const routeId = Number(link.routeId ?? route?.id ?? 0);
  const number = route?.number != null ? String(route.number).trim() : '';
  const directionRaw = route
    ? applicationRouteDirectionLabel({
        loadingCity: route.loadingCity,
        unloadingCity: route.unloadingCity,
        loadingAddress: route.loadingAddress,
        unloadingAddress: route.unloadingAddress,
      })
    : '';
  return {
    linkId: link.id,
    routeId,
    label: number || `№${routeId}`,
    carrierName: route?.carrier?.name?.trim() || null,
    status: String(route?.status ?? ''),
    rateAmount:
      route?.totalAmount != null && Number.isFinite(Number(route.totalAmount))
        ? Number(route.totalAmount)
        : null,
    direction: directionRaw?.trim() || '—',
    plannedLoadingDate: formatRouteDate(route?.plannedLoadingDate),
    plannedUnloadingDate: formatRouteDate(route?.plannedUnloadingDate),
    actualLoadingDate: formatRouteDate(route?.actualLoadingDate),
    actualUnloadingDate: formatRouteDate(route?.actualUnloadingDate),
  };
}

export function projectApplicationLinkedRoutes(application: Application): ApplicationLinkedRouteRow[] {
  return (application.routes ?? []).map(projectRouteRow);
}
